import { pretreatReportFetchParam } from '@duoke/tools/umd/report';

export const preTreatReportFetchParamV2 = ({ config, custom }: any) => {
  const ret = pretreatReportFetchParam({ config, custom });
  const styleKey = config.info.styleKey;
  if (styleKey) {
    switch (styleKey) {
      case '1':
        ret.precisions = [ret.precision];
        break;
      case '11':
        ret.precisions = config.precisions[0].options.map((p) => p.value);
        break;
      case '12':
        ret.precisions = (custom?.precisions?.length ?? 0) > 0 ?
          custom.precisions :
          config.precisions[0].options.filter((o: any) => o.isSelected).map((o: any) => o.value);
        break;
    }
    const precisions = ret.precisions;
    const views = ret.views.filter(
      (v) =>
        (!v.precisionKeys) || v.precisionKeys.length === 0 || (v.precisionKeys.some(key => precisions.includes(key))),
    );
    ret.views = views;
  }
  return ret;
};

